import QrCode from "../../../jsx/components/Dashboard/QrCode/QrCode";

const KYCWrapper = () => {
  return <QrCode />;
};

export const allowedRoles = [_enum.ROUTE_PERSONAS.connector];

export default constore(KYCWrapper);
